import React from 'react'
import { Breadcrumb } from '@center/ui-kit'

import Grayscale from './Grayscale'
import Legends from './Legends'
import Zoom from './Zoom'
import Heatmap from './Heatmap'
import FloorsNavigation from './FloorsNavigation'
import { LeftControls, RightControls } from './ControlsStyles'

const Control = ({
  legendProps,
  zoomProps,
  breadcrumbProps,
  activeEquipment,
  grayscaleProps,
  panningProps,
  heatmapProps = {},
  floorsNavigationProps = {},
  ...props
}) => {
  return (
    <>
      <RightControls {...props}>
        <Heatmap {...heatmapProps} mapsView={zoomProps?.mapsView}/>
        <Grayscale {...grayscaleProps} mapsView={zoomProps?.mapsView}/>
        <Legends {...legendProps} />
        <FloorsNavigation {...floorsNavigationProps} />
        <Zoom {...zoomProps}/>
      </RightControls>
      <LeftControls>
        {activeEquipment}
        {breadcrumbProps?.showBreadcrumb && <Breadcrumb {...breadcrumbProps} />}
      </LeftControls>
    </>
  )
}

export default Control